define('common/ko/fn/resetAfter',[
    'knockout',
    'underscore'
], function (ko, _) {

    /* eslint-disable max-len */
    var ERROR_MESSAGES = {
        RESET_TIMEOUT_NOT_A_NUMBER: 'resetTimeout argument is not a valid number. Usage: yourObservable.resetAfter(<Integer>)'
    };
    /* eslint-enable max-len */

    /**
     * Use this when you want a value to reset to its original value after some timeout.
     * The timeout is refreshed if the target is updated with a different value.
     *
     * @param  {Integer} resetTimeout - reset timeout in milliseconds
     */
    ko.subscribable.fn.resetAfter = function (resetTimeout) {
        var self = this,
            originalValue,
            timerId;

        if (!_.isInteger(resetTimeout)) {
            throw new Error(ERROR_MESSAGES.RESET_TIMEOUT_NOT_A_NUMBER);
        }

        return ko.pureComputed({
            read: self,
            write: function (newValue) {

                if (_.isEqual(self(), newValue)) {
                    return;
                }

                if (_.isUndefined(originalValue)) {
                    originalValue = self();
                }

                self(newValue);

                if (timerId) {
                    window.clearTimeout(timerId);
                }

                timerId = window.setTimeout(function resetValueCallback () {
                    self(originalValue);
                    originalValue = null;
                    timerId = null;
                }, resetTimeout);

            }
        });

    };
});

